import { InstallSpec, ItemComponent } from "../../../install/types.ts";

export const RdpComponents = InstallSpec({
  "iam-write": ItemComponent({
    type: "dynamic",
    label: "RDP access control",
    description: "Allows P0 to provide RDP access to compute instances",
    maturity: "ga",
    schema: {
      // ENG-6398: Custom RDP roles
    },
  }),
});
